export function safeRedirect(path) {
  // Default fallback
  if (!path || typeof path !== 'string') return '/dashboard';

  // Must be internal path only (start with '/')
  if (!path.startsWith('/')) return '/dashboard';

  // Basic open-redirect protection: disallow protocol or leading '//' cases
  // Examples disallowed:
  // - https://evil.com
  // - //evil.com
  // - /\/\evil
  if (path.startsWith('//')) return '/dashboard';
  if (path.includes('://')) return '/dashboard';

  // Allow query/hash; just ensure it remains internal.
  return path;
}
